var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"Sélectionner une catégorie de filtre","value":_vm.value,"loading":_vm.loading},on:{"change":function($event){return _vm.$emit('input', $event)}}},[_vm._t("default"),_vm._l((_vm.groups),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }